import './Ball.scss';

export const Ball = ({ number, width, fontSize, className }: { number: number, width?: number, fontSize?: number, className?: string }) => {
  return (
    <div className="ball-component flex-center" style={{
      width: width ? width + 'px' : '100%',
      height: width ? width + 'px' : '100%',
    }}>
      <div className={`number flex-center ${className}`} style={{ fontSize: fontSize + 'px' }}>{number}</div>
    </div>
  );
}
